import styles from './style.module.css'


const SchoolCardList = ({ children }) => {
  return (
    children
  )
}

export default SchoolCardList